import { RadioGroup as RadioGroupRoot } from '@headlessui/react';
import classNames from 'classnames';
import { forwardRef } from 'react';

interface Props {
  label: string;
  id: string;
  error?: string;
  isDirty?: boolean;
  onChange: (selected: string) => void;
  options: string[];
  value: string | undefined;
}

type Ref = HTMLDivElement;

const ReadioGroup = forwardRef<Ref, Props>(
  ({ error, id, isDirty, label, onChange, options, value }, ref) => {
    return (
      <div className="relative group">
        <label
          htmlFor={id}
          className={classNames(
            'block mb-2 text-15 leading-140 text-blue-800',
            {
              'text-blue-800': !error,
            },
            { 'text-error': error },
          )}>
          {label}
        </label>
        <RadioGroupRoot
          className="flex items-center gap-4"
          id={id}
          ref={ref}
          onChange={onChange}
          value={value}>
          {options.map((option) => (
            <div key={option} className="flex items-center gap-2">
              <RadioGroupRoot.Option
                value={option.toLowerCase()}
                className="group flex size-5 items-center justify-center rounded-full border bg-white">
                {({ checked }) => {
                  return (
                    <span
                      className={classNames(
                        'size-3 rounded-full',
                        {
                          invisible: !checked,
                          visible: checked,
                        },
                        {
                          'bg-blue-800': !error,
                        },
                        {
                          'bg-error': error,
                        },
                      )}
                    />
                  );
                }}
              </RadioGroupRoot.Option>
              <RadioGroupRoot.Label className="text-11 uppercase font-bold">
                {option}
              </RadioGroupRoot.Label>
            </div>
          ))}
        </RadioGroupRoot>
        {error && (
          <div className="text-error text-11 px-7 pt-1 font-medium">
            {error}
          </div>
        )}
      </div>
    );
  },
);

ReadioGroup.displayName = 'RadioGroup';

export default ReadioGroup;
